module.exports = __webpack_public_path__ + "img/3DBanner.d87f31cd.png";